module.exports = __webpack_public_path__ + "img/06.e166f8a0.jpg";